// extracted by mini-css-extract-plugin
export default {"root":"IconLogo_root__hWM2P"};